// extracted by mini-css-extract-plugin
export var childrenContainer = "_bx-0";
export var virtualScrollArea = "_bx-1";